import { render, staticRenderFns } from "./EditorTab.vue?vue&type=template&id=54ba16b4&scoped=true"
import script from "./EditorTab.vue?vue&type=script&lang=js"
export * from "./EditorTab.vue?vue&type=script&lang=js"
import style0 from "./EditorTab.vue?vue&type=style&index=0&id=54ba16b4&prod&scoped=true&lang=sass"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54ba16b4",
  null
  
)

export default component.exports